import {
  Button,
  FormControl,
  FormErrorMessage,
  FormLabel,
  Icon,
  Input,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  useDisclosure,
  useToast,
} from "@chakra-ui/react";
import React, { useState } from "react";
import { BlogKategori } from "../../const/types";
import { useFormik } from "formik";
import * as yup from "yup";
import cr from "../../lib/request";
import useTrigger from "../../globalState/useTrigger";
import { PencilSimpleLine } from "@phosphor-icons/react";
import { iconSize } from "../../const/sizes";
import Textarea from "../Textarea";
import RequiredForm from "../RequiredForm";

type Props = {
  data: BlogKategori;
};

export default function UpdateBlogKategoriModal({ data }: Props) {
  const { isOpen, onOpen, onClose } = useDisclosure();

  const [loading, setLoading] = useState<boolean>(false);
  const { trigger, setTrigger } = useTrigger();
  const toast = useToast();

  const formik = useFormik({
    validateOnChange: false,

    initialValues: {
      name: data.name,
      description: data.description,
    },

    validationSchema: yup.object().shape({
      name: yup.string().required("Nama Kategori harus diisi"),
      description: yup.string().required("Deskripsi Kategori harus diisi"),
    }),

    onSubmit: (values, { resetForm }) => {
      setLoading(true);
      const url = `api/blog/categories/${data.id}/update`;
      const payload = new FormData();
      payload.append("name", values.name);
      payload.append("description", values.description);

      cr.post(url, payload)
        .then((r) => {
          if (r.status === 200) {
            toast({
              title: r.data.message,
              status: "success",
              duration: 5000,
              isClosable: true,
            });
            setTrigger(!trigger);
          }
        })
        .catch((e) => {
          console.log(e);
          toast({
            title: e.response.data.message,
            status: "error",
            duration: 5000,
            isClosable: true,
          });
        })
        .finally(() => {
          setLoading(false);
        });
    },
  });

  return (
    <>
      <Button
        leftIcon={<Icon as={PencilSimpleLine} fontSize={iconSize} />}
        onClick={onOpen}
        colorScheme="ap"
        variant={"ghost"}
        pl={3}
        className="clicky"
      >
        Update
      </Button>

      <Modal isOpen={isOpen} onClose={onClose}>
        <ModalOverlay />

        <ModalContent>
          <ModalHeader>Ubah Kategori</ModalHeader>

          <ModalBody>
            <form id="updateBlogKategoriForm" onSubmit={formik.handleSubmit}>
              <FormControl mb={4} isInvalid={formik.errors.name ? true : false}>
                <FormLabel>
                  Nama Kategori
                  <RequiredForm />
                </FormLabel>
                <Input
                  name="name"
                  placeholder="Masukkan nama kategori"
                  onChange={formik.handleChange}
                  value={formik.values.name}
                />
                <FormErrorMessage>{formik.errors.name}</FormErrorMessage>
              </FormControl>

              <FormControl isInvalid={formik.errors.description ? true : false}>
                <FormLabel>
                  Dskripsi Kategori
                  <RequiredForm />
                </FormLabel>
                <Textarea
                  name="description"
                  formik={formik}
                  placeholder="Masukkan nama kategori"
                />
                <FormErrorMessage>{formik.errors.description}</FormErrorMessage>
              </FormControl>
            </form>
          </ModalBody>

          <ModalFooter gap={2}>
            <Button onClick={onClose} className="btn clicky">
              Batal
            </Button>

            <Button
              type="submit"
              form={"updateBlogKategoriForm"}
              colorScheme="p"
              className="clicky"
              isLoading={loading}
            >
              Update
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
}
